import { Accordion as FluentAccordion } from "@fluentui/web-components";
/**
 * Accordion
 * @summary An Accordion Custom HTML Element that implements ARIA Accordion, allowing for single or multiple item expansion.
 *
 * @example
 * ```html
 * <fabric-accordion expand-mode="multi">
 *   <fabric-accordion-item>Item 1</fabric-accordion-item>
 *   <fabric-accordion-item>Item 2</fabric-accordion-item>
 *   <fabric-accordion-item>Item 3</fabric-accordion-item>
 * </fabric-accordion>
 * ```
 *
 * @attr {AccordionExpandMode} expand-mode - Controls the expand mode of the Accordion, either allowing single or multiple item expansion.
 *
 * @prop {AccordionExpandMode} expandmode - Controls the expand mode of the Accordion, either allowing single or multiple item expansion.
 *
 * @slot - The default slot for the accordion items
 *
 * @method expandmodeChanged - Called when the expand mode changes.
 * @method findExpandedItem - Find the first expanded item in the accordion.
 * @method isSingleExpandMode - Checks if the accordion is in single expand mode.
 * @method setSingleExpandMode - Controls the behavior of the accordion in single expand mode.
 *
 * @fires change - Fires a custom 'change' event when the active item changes.
 *
 * @extends FluentAccordion
 * @tagname fabric-accordion
 * @public
 */
export class Accordion extends FluentAccordion {
}
//# sourceMappingURL=accordion.js.map